import styled, { css } from "styled-components";
import { px2rem } from "../../../../utils/css";

export const CountDownBox = styled.div`
	position: absolute;
	bottom: 0;
	right: 0;
	z-index: 1;
	width: 100%;
	display: flex;
	width: inherit;
	height: ${px2rem(21)};
	justify-content: center;
	align-items: center;
	background: rgba(0, 0, 0, 0.4);
	gap: ${px2rem(6)};
`;

export const Time = styled.div`
	height: ${px2rem(16)};
	line-height: ${px2rem(16)};
	font-size: 12px;
	font-weight: 500;
	color: #ffffff;
`;
export const CountDIcon = styled("i").withConfig({
	shouldForwardProp: (prop) => !["height"].includes(prop),
})<{ height?: string }>`
	font-size: ${px2rem(12)};
	color: white;

	${(props: { height?: string }) => {
		if (props.height) {
			return css`
				height: ${props.height};
			`;
		}
		return "";
	}}
`;
